// extracted by mini-css-extract-plugin
export default {"control":"NavbarLinksGroup_control__+zseW","link":"NavbarLinksGroup_link__RIXF0","chevron":"NavbarLinksGroup_chevron__awI6P","nav_active":"NavbarLinksGroup_nav_active__sa37D"};